// Third party
import React, { Component } from 'react';
import { Grid, Row, Image, Col } from "react-bootstrap";

// Other
import googleAnalyticsKeys from '../../../utils/googleAnalyticsKeys';
import * as googleAnalyticsUtil from '../../../utils/googleAnalyticsUtil';

import './styles.css'

export class Footer extends Component {

    handleFacebookClick = () => {
        googleAnalyticsUtil.raiseEvent({
            category: googleAnalyticsKeys.categories.EXTERNAL_LINK_NAVIGATION,
            action: googleAnalyticsKeys.actions.CLICK_FACEBOOK_LINK
        });
        window.open("https://www.facebook.com/identifixit/", "_blank");
    }

    handleLinkedInClick = () => {
        googleAnalyticsUtil.raiseEvent({
            category: googleAnalyticsKeys.categories.EXTERNAL_LINK_NAVIGATION,
            action: googleAnalyticsKeys.actions.CLICK_LINKEDIN_LINK
        });
        window.open("https://www.linkedin.com/company/2385376", "_blank");
    }

    handleTwitterClick = () => {
        googleAnalyticsUtil.raiseEvent({
            category: googleAnalyticsKeys.categories.EXTERNAL_LINK_NAVIGATION,
            action: googleAnalyticsKeys.actions.CLICK_TWITTER_LINK
        });
        window.open("https://twitter.com/identifixit/", "_blank");
    }

    handleSecurityAndPrivacyClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_SECURITY_AND_PRIVACY_LINK
    })

    handleTermsAndConditionsClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_TERMS_AND_CONDITIONS_LINK
    })

    handleContactUsClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_CONTACT_US_LINK
    })

    render() {
        const baseUrl = this.props.callbackUrl;

        return (
            <Row bsClass="footer">
                <Row bsClass="footer-background"></Row>
                <Image className="footer-bubbles" src="/images/layout-bubbles.svg" alt="" />
                <Grid bsClass="footer-content">
                    <Row>
                        <Col sm={3} md={3} className="footer-social-network">
                            <Image id="facebook-logo" className="image-cusor" alt="Facebook-logo" src="/images/logo-facebook.svg" onClick={this.handleFacebookClick} />
                            <Image id="linked-in-logo" className="footer-linked-in-logo image-cusor" alt="Linked-In" src="/images/logo-linked-in.svg" onClick={this.handleLinkedInClick} />
                            <Image id="twitter-logo" className="image-cusor" alt="Twitter-Logo" src="/images/logo-twitter.svg" onClick={this.handleTwitterClick} />
                        </Col>
                        <Col sm={12} md={9}>
                            <Grid bsClass="footer-contact-links">
                                <p id="copyright" className="footer-copyright">Copyright &copy;{new Date().getFullYear()} Solera Holdings, Inc. All rights reserved.</p>
                                <p id="footer-links" className="footer-links">
                                    <a id="security-and-privacy-link" className="footer-link" href={`${baseUrl}security-and-privacy`} onClick={this.handleSecurityAndPrivacyClick}>
                                        Security &amp; Privacy
                                    </a>
                                    &nbsp;|&nbsp;
                                    <a id="terms-and-conditions-link" className="footer-link" href={`${baseUrl}terms-and-conditions`} onClick={this.handleTermsAndConditionsClick}>
                                        Rewards Terms &amp; Conditions
                                    </a>
                                    &nbsp;|&nbsp;
                                    <a id="contact-us-link" className="footer-link" href={`${baseUrl}contact-us`} onClick={this.handleContactUsClick}>
                                        Contact Us
                                    </a>
                                </p>
                            </Grid>
                        </Col>
                    </Row>
                </Grid>
            </Row>
        )
    }
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/common/footer/index.js